export const ProposalFilterType = {
  PROPOSAL_FILTER_6: 1,
  PROPOSAL_FILTER_OTHER: 2,
}
